export const urls = {
  GET_MASINE_COMBO: 'Combo/vrati_tipove_masina_combo',
  GET_DATA: 'KategorijeDokumenata/dokumentacija_kategorije_pregled',
  DELETE_DATA: 'KategorijeDokumenata/dokumentacija_kategorije_brisanje',
  UNOS_DATA: 'KategorijeDokumenata/dokumentacija_kategorije_IU',
  IZMENA_DATA: 'KategorijeDokumenata/dokumentacija_kategorije_IU',
};
